import { Component, inject } from '@angular/core';
import { DebugService, IndexDbRequest } from "@api/api";
import { TravelDocumentIndexedDbService } from "@core/storage/indexedDb/travel-document-database.service";
import { TripIndexedDbService } from "@core/storage/indexedDb/trip-database.service";
import { ToastService } from "@core/services/toast.service";
import { IonButton } from "@ionic/angular/standalone";

// eslint-disable-next-line
declare var require: any;

@Component({
  selector: 'pkp-db-dumper',
  templateUrl: './db-dumper.component.html',
  styleUrls: ['./db-dumper.component.scss'],
  imports: [
    IonButton
  ]
})
export class DbDumperComponent {
  version = require('package.json').version;
  #debugService = inject(DebugService);
  #travelDocumentIndexedDbService = inject(TravelDocumentIndexedDbService);
  #tripIndexedDbService = inject(TripIndexedDbService);
  #toastService = inject(ToastService);
  #clickCount = 0;
  #timeoutId?: any;

  handleRapidClick() {
    this.#clickCount++;

    if (this.#clickCount === 1) {
      this.#timeoutId = setTimeout(() => {
        this.#clickCount = 0;
      }, 5000);
    }

    if (this.#clickCount === 5) {
      this.sendDbDump();
      clearTimeout(this.#timeoutId);
      this.#clickCount = 0;
    }
  }

  private async sendDbDump() {
    try {
      const indexDbRequest = {} as IndexDbRequest;
      try {
        indexDbRequest.travelDocuments = await this.#travelDocumentIndexedDbService.getFullDb();
      } catch {
        this.#toastService.message('Menetigazolvány kiolvasása sikertelen', {type: 'danger'});
      }
      try {
        indexDbRequest.trips = await this.#tripIndexedDbService.getFullDb();
      } catch {
        this.#toastService.message('Utazások kiolvasása sikertelen', {type: 'danger'});
      }

      this.#debugService.logIndexedDBData(indexDbRequest).subscribe(() => {
        this.#toastService.message('Utazások elküldése sikeres', {type: 'success'});
      });
    } catch {
      this.#toastService.message('Adatok elküldése sikertelen', {type: 'danger'});
    }

  }
}
